import Model from '@/lib/data/Model';

class Notif extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'title',
        'body',
        'from_id',
        'to_id',
        'record_date_utc',
        'modification_date_utc',
        {
            name: 'unread_flag',
            defaultValue: true,
        },
    ];

    get isUnread() {
        return this.unread_flag;
    }

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'mark',
            url: '/user/notification/mark',
            params: ['id', 'unread_flag'],
            method: 'POST',
        },
        {
            name: 'markAllRead',
            url: '/user/notification/markallread',
            method: 'POST',
        },
        {
            name: 'markIdsRead',
            url: '/user/notification/markidsread',
            params: ['ids'],
            method: 'POST',
        },
    ];
}

export default Notif;
